module.exports = __webpack_public_path__ + "static/media/money.0ba2bdc3.svg";